import { RotateCcw } from 'lucide-react'
import { Button } from '~/components/ui/button'

export interface ExploreBreadcrumbProps {
    parts: string[]
    count: number
    onReset(): void
    showReset?: boolean
}

/** 현재 탐색 경로와 결과 수를 한 줄로 요약한다. */
export function ExploreBreadcrumb({
    parts,
    count,
    onReset,
    showReset = true,
}: ExploreBreadcrumbProps) {
    const hasFilters = parts.length > 0

    return (
        <div className='flex flex-wrap items-center gap-2 text-sm'>
            <span className='text-muted-foreground'>현재 범위</span>
            <span className='text-foreground font-bold'>
                {hasFilters ? parts.join(' › ') : '전체'}
            </span>
            <span className='text-primary font-bold'>{count}개</span>
            {hasFilters && showReset ? (
                <Button
                    type='button'
                    variant='outline'
                    size='sm'
                    onClick={onReset}
                    className='h-7 rounded-sm px-2 text-xs'>
                    <RotateCcw className='size-3.5' />
                    초기화
                </Button>
            ) : null}
        </div>
    )
}
